import { isArray } from 'lodash-es';

export const handleCopyToClipboard = (name?: string[] | string) => {
  const parsedName = isArray(name) ? name.join('•') : name;

  navigator.clipboard.writeText(parsedName ?? 'unknown name');
};
